import { UserAssetCategory, UserAssetCategoryItemType } from './components';
import React from 'react';

export interface UserAssetFolderListProps {
  className: string;
  folderTreeList: UserAssetCategoryItemType;
  selectedFolder: { id: string; name: string } | null;
  onSelectFolder: (folder: { id: string; name: string } | null) => void;
}

export function UserAssetFolderList(props: UserAssetFolderListProps) {
  const { className, selectedFolder, folderTreeList, onSelectFolder } = props;

  return (
    <UserAssetCategory
      className={className}
      depth={0}
      data={folderTreeList}
      selectedFolder={selectedFolder}
      onSelectFolder={onSelectFolder}
    />
  );
}
